'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mainSelector = require('./mainSelector');

var _mainSelector2 = _interopRequireDefault(_mainSelector);

var _InboxContainer = require('../../inbox/InboxContainer');

var _InboxContainer2 = _interopRequireDefault(_InboxContainer);

var _Canvas = require('../../canvas/Canvas');

var _Canvas2 = _interopRequireDefault(_Canvas);

require('./Main.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Selectors
// Lib
var Main = function Main(props) {
    var classes = {
        'is-dragging': props.isDragging,
        'no-toolbar': !props.isEditable,
        editable: props.isEditable
    };

    if (!props.currentBoardId || !props.currentBoard) return null;

    return _react2.default.createElement(
        'main',
        { className: (0, _classnames2.default)('Main', classes) },
        _react2.default.createElement(_Canvas2.default, props),
        _react2.default.createElement(_InboxContainer2.default, props)
    );
};

// Styles


// Components


Main.propTypes = {
    isDragging: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    currentBoardId: _propTypes2.default.string,
    currentBoard: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(_mainSelector2.default)(Main);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/main/Main.js
// module id = 2199
// module chunks = 0